import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import ActivityLog from './ActivityLog';
import DataExportPanel from './DataExportPanel';
import { messages } from './DataProtection.i18n';


class DataProtection extends React.Component {
  render = () => (
    <div className="row" id="body">
      <div className="col">
        <h1 id="content" tabIndex="0" role="form">
          <span className="title"><FormattedMessage { ...messages.page.title } /></span>
        </h1>
        <p tabIndex="0"><FormattedMessage { ...messages.page.subTitle } /></p>
        <ActivityLog />
        <DataExportPanel />
      </div>
    </div>
  );
}

DataProtection.propTypes = {
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  language: PropTypes.string,
};

const mapStateToProps = (state) => (
  {
    language: state.language.languageCode,
  }
);

export default connect(mapStateToProps)(DataProtection);
